import React from "react";
import { AppContext } from "../AppContext.js";
import { RestReportBean } from "../ds/client_ds.js";
import { InfoListPrintRequest, InfoSearchCriteria } from "../ds/ds.js";
import {
  AlertToolBox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import { isEmptyArray, isEmptyString, } from "../gui_components/Util.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { PopupVendorModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class VendorInfo extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Vendor Info Inquiry",
      isShowExecuteButton: true,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      criteria: new InfoSearchCriteria(),
      isShowAlert: false,
      alertMessage: [],
      alertType: "",
      success_list: [],
      isShowVendorModule: false,
      moduleForPopup: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isInquiryDatasFound: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    this.loadPage(1);
  }
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage();
  };
  loadPage = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing ...",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.infoType = 3;
    this.loadVendorInfoInquiryList(criteria);
  };
  loadVendorInfoInquiryList = (listRequest) => {
    if (SecurityAccessManager.VendorInfoInquiry_IsAccessible()) {
      ReportService.inquireMultiInfoPageList(
        listRequest,
        this.loadVendorInfoPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadVendorInfoPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let vendorDataList = new Array();
      if (!isEmptyArray(response.data.result.vendorDetails)) {
        vendorDataList = response.data.result.vendorDetails;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        inquiryDataList: vendorDataList,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateVendorInfoReport = (reportType) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new InfoListPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    if (reportBean.reportType == 1) {
      if (SecurityAccessManager.VendorInfoInquiryPDFReport_IsAccessible()) {
        ReportService.generateVendorInfoListPrintReport(
          listRequest,
          this.generateVendorInfoPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (SecurityAccessManager.VendorInfoInquiryExcelReport_IsAccessible()) {
        ReportService.generateVendorInfoListPrintReport(
          listRequest,
          this.generateVendorInfoPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateVendorInfoPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error :" + error);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  generatePDF = () => {
    this.generateVendorInfoReport(1);
  };
  generateExcel = () => {
    this.generateVendorInfoReport(2);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewVendorModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowVendorModule: true,
          moduleForPopup: (
            <PopupVendorModule
              vendorCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({
      isShowAlert: isDisplayed,
      error_list: [],
    });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowVendorModule: isOpen,
      moduleForPopup: [],
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Vendor#",
          "vendorCode",
          true
        )
        .setStyleDetails("left", "6", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewVendorModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "VendorName",
          "vendorName",
          true
        )
        .setStyleDetails("left", "8", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("NickName", "nickName", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VendorType", "vendorTypeCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ShipmentTerm", "shipmentTermsCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("FobCity", "fobCity", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ShipVia", "vendorShipViaCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Currency", "vendorCurrencyCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Address", "vendorAddress", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getAddress)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("City", "vendorAddress", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getCity)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("State", "vendorAddress", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getState)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Country", "vendorAddress", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getCountry)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Email", "vendorAddress", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getEmail)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Mobile", "vendorAddress", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getMobileNumber)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Phone", "vendorAddress", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getPhone)
    );
    return columns;
  };
  getAddress = (value) => {
    let address = "";
    address = value.address1;
    return address;
  };
  getCity = (value) => {
    let city = "";
    city = value.city;
    return city;
  };
  getState = (value) => {
    let state = "";
    state = value.state;
    return state;
  };
  getCountry = (value) => {
    let country = "";
    country = value.country;
    return country;
  };
  getEmail = (value) => {
    let email = "";
    email = value.email;
    return email;
  };
  getMobileNumber = (value) => {
    let mobileNumber = "";
    mobileNumber = value.mobileNumber;
    return mobileNumber;
  };
  getPhone = (value) => {
    let phone1 = "";
    phone1 = value.phone1;
    return phone1;
  };
  
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    return (
      <div>
        <ProgressBar
          isShowPopup={this.state.isShowProgressBarPopup}
          progressLoadingText={this.state.progressLoadingText}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          {...this.state}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
              enableVritualizer={true}
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          closeOnEsc={false}
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
function VendorInfoInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <VendorInfo {...props} name="" /> <br />
    </div>
  );
}

export default VendorInfoInquiry;
